import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import tickSrc from "./tick-icon.svg";

export const createTestQuestionStyles = ({
  borderRadius,
  spacing,
  typography,
  boxShadows,
  palette,
}: Theme) => {
  return {
    root: css({}),
    question: css({
      fontSize: typography.pxToRem(16),
      lineHeight: 1.4,
    }),
    answerRadio: css({
      margin: spacing([2, 0]),
      "[type='radio']:checked": {
        "& + label::before": {
          borderRadius: borderRadius.checkboxRadio,
          boxShadow: boxShadows.answerRadio,
          width: 40,
          height: 40,
        },
        "& + label": {
          "&::after": {
            content: "''",
            position: "absolute",
            width: 14,
            height: 11,
            left: 20,
            top: 9,
            background: `url(${tickSrc})`,
          },
          "&:hover::before": {
            border: 0,
          },
        },
        "&:focus +label::before": {
          border: 0,
        },
      },
    }),
    answerLabel: css({
      padding: spacing([0, 0, 0, 6]),
      fontSize: typography.pxToRem(16),
      fontWeight: typography.fontWeight.normal,
      color: grey[950],
      lineHeight: 1.4,
      "&::before": {
        width: 40,
        height: 40,
        color: "transparent",
        display: "block",
        content: "''",
        borderRadius: borderRadius.checkboxRadio,
        transition: `background-color 0.25s, border-color 0.25s`,
        background: grey[200],
        position: "absolute",
        top: 9,
        left: 0,
        boxSizing: "border-box",
      },
    }),
    errorAnswerLabel: css({
      "&::before": {
        backgroundColor: palette.default.background,
        border: `1px solid ${grey[500]}`,
      },
    }),
  };
};
